import React from 'react';
import styles from './StepItem.css';

function StepItem(props) {
  const { number, title, children, position, info, color } = props;
  return (
    <div className={styles.wrapper}>
      <div
        className={`${styles['border-step']} ${styles[position]} ${
          styles[`step-${color}`]
        }`}
      />
      <p className={styles.info}>{info}</p>
      <div className={`${styles.number} ${styles[`circle-${color}`]}`}>
        {number}
      </div>
      <p className={styles.title}>{title}</p>
      <p className={styles.desc}>{children}</p>
    </div>
  );
}

export default StepItem;
